import "core-js/modules/es.object.to-string.js";
export default function getAccumulatedCompletionTime(items) {
  return items.reduce(function (acc, item) {
    return item.completionTime !== undefined ? acc + item.completionTime : acc;
  }, 0);
}